import React, { useEffect, useState } from 'react';
import { Dropdown, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import api, { type User } from '../../service/api';

interface UserDropdownProps {
  selectedUserId: string | null;
  onUserSelect: (userId: string | null) => void;
}

const UserDropdown: React.FC<UserDropdownProps> = ({
  selectedUserId,
  onUserSelect,
}) => {
  const { t } = useTranslation();
  const [users, setUsers] = useState<User[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const fetchedUsers = await api.usersGetAll();
        setUsers(fetchedUsers);
      } catch (error) {
        console.error('Failed to fetch users:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const selectedUser = users.find(user => user._id === selectedUserId);

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="light"
        className="d-flex align-items-center gap-2 rounded-pill border-0"
        style={{ height: '2rem' }}
        disabled={isLoading}
      >
        {isLoading ? (
          <Spinner animation="border" size="sm" />
        ) : (
          <span className="text-dark small fw-medium">
            {selectedUser
              ? selectedUser.given_name
              : t('manager.tasks.allUsers')}
          </span>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item className="pt-3 pb-3" onClick={() => onUserSelect(null)}>
          {t('manager.tasks.allUsers')}
        </Dropdown.Item>
        <Dropdown.Divider />
        {users.map(user => (
          <Dropdown.Item
            className="pt-3 pb-3"
            key={user._id}
            onClick={() => onUserSelect(user._id)}
            active={selectedUserId === user._id}
          >
            {user.given_name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default UserDropdown;
